<div [ngClass]="navBarClass()" id="logo-ssh-navbar" >
    <div [ngClass]="headerClass()" id="logo-ssh-header">
      <img [ngClass]="imgClass()" id="logo-ssh-logo" src="{{ img () }}" />
    </div>
    <div [ngClass]="taglineClass()" id="logo-ssh-tagline">
      <span class="navbar-text">{{ text () }}</span>
    </div>      
</div>
